document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('details').forEach(details => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('.toggle-content');

        if (!summary || !content) return;

        // Initialize height
        content.style.height = details.open ? 'auto' : '0px';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.4s ease';

        summary.addEventListener('click', e => {
            e.preventDefault(); // Prevent native toggle

            if (details.open) {
                // Animate close
                content.style.height = content.scrollHeight + 'px';
                content.offsetHeight; // force reflow
                content.style.height = '0px';

                // Delay removing the "open" attribute until after transition
                setTimeout(() => {
                    details.removeAttribute('open');
                }, 400);
            } else {
                // Animate open
                details.setAttribute('open', ''); // needed so content is visible
                const height = content.scrollHeight;

                content.style.height = '0px';
                content.offsetHeight; // force reflow
                content.style.height = height + 'px';

                // After transition, allow natural height
                setTimeout(() => {
                    if (details.open) {
                        content.style.height = 'auto';
                    }
                }, 400);
            }
        });
    });
});
